import { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import LocaleContext from '../contexts/locale';

const all = [];
const map = {};

const useBlockContact = () => {
	const {
		allMarkdownRemark: {
			edges: blocks
		}
	} = useStaticQuery(query);

	const {
		currentLocale
	} = useContext(LocaleContext);

	const mapItem = ({
		node: {
			id,
			fields,
			frontmatter: data
			
		}
	}) => ({
		...data,
		...fields,
		...{
			id
		}
	});
	
	if (all.length === 0) {
		for (let block of blocks) {
			const item = mapItem(block);
			const { locale } = item;

			map[locale] = item;
			all.push(item);
		}
	}

	return map[currentLocale];
}

export default useBlockContact;

const query = graphql`
	query useBlockContactQuery {
		allMarkdownRemark(
	    	filter: {
		        frontmatter: {
		          type: {
		            eq: "block"
		          }
		          name: {
		          	eq: "contact"
		          }
		        }
		  	}
	  	)
	  	{
			edges {
				node {
					id
					frontmatter {
						title
						text
						button_text
						button_link
						icon {
							publicURL
						}
					}
					fields {
						locale
					}
				}
			}
		}
	}
`;